import * as React from 'react'

import { Text, Title } from 'main/ui'

import { Container, DescriptionContainer } from './Description.styles'

interface IProps {
  description: string
  title: string
}

export default function Description(props: IProps) {
  const { description, title } = props

  return (
    <Container>
      <Title kind="large">{title}</Title>
      <DescriptionContainer>
        <Text muted>{description}</Text>
      </DescriptionContainer>
    </Container>
  )
}
